export function AccountRecoveryPage() {
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-semibold">Account Recovery</h1>
      <p className="text-muted-foreground">Manage account recovery requests.</p>
    </div>
  );
}
